import { FC, memo } from 'react'

import { DOCUMENTS_PATH } from 'commons/constants/routes'
import { PageSection, PageSectionFace } from 'ui/components'
import { useAlertsContext } from '~bank-alerts/context'

import { AlertedItem } from './components'

import * as SC from './styles'

export const DocumentsDue: FC = memo(() => {
  const { data } = useAlertsContext()

  const {
    documentsFirstNotificationCount,
    documentsPastNotificationCount,
    documentsLastNotificationCount,
    documentsPreNotificationCount,
    documentsIncompleteCount,
    documentsDaysToFirstNotificationBeforeExpiration,
    documentsDaysToLastNotificationBeforeExpiration,
    documentsDaysToPreNotificationBeforeExpiration
  } = data

  return (
    <PageSection title="Documents Due" face={PageSectionFace.PRIMARY} anchor="documents-due">
      <SC.AlertedItemsWrapper>
        <AlertedItem
          isPast
          overallCount={documentsPastNotificationCount}
          daysDue={0}
          url={`${DOCUMENTS_PATH}?alerts=past-due`}
        />
        <AlertedItem
          overallCount={documentsLastNotificationCount}
          daysDue={documentsDaysToLastNotificationBeforeExpiration || 3}
          url={`${DOCUMENTS_PATH}?alerts=last-alert`}
        />
        <AlertedItem
          overallCount={documentsFirstNotificationCount}
          daysDue={documentsDaysToFirstNotificationBeforeExpiration || 7}
          url={`${DOCUMENTS_PATH}?alerts=first-alert`}
        />
        <AlertedItem
          overallCount={documentsPreNotificationCount}
          daysDue={documentsDaysToPreNotificationBeforeExpiration || 30}
          url={`${DOCUMENTS_PATH}?alerts=initial-alert`}
        />
        <AlertedItem isIncomplete overallCount={documentsIncompleteCount} url={`${DOCUMENTS_PATH}?alerts=incomplete`} />
      </SC.AlertedItemsWrapper>
    </PageSection>
  )
})
